import { z, ZodError } from 'zod';
import * as CryptoJS from 'crypto-js';
import { LRUCache } from 'typescript-lru-cache';

const cache = new LRUCache<string, string>({
    maxSize: 100,
    entryExpirationTimeInMS: 5 * 60 * 1000
});

export const fetchJsonData = async (blobPath: string, consumeError: boolean = false): Promise<string> => {
    var Aliasses =  JSON.parse(JSON.stringify(await fetchJsonDataOverride('aliasses.json')));
        //http://localhost:3000/programmes/online-Professional%20Development%20Courses--effective-change-management--preparing-yourself-and-your-team
    
        // course-listing
    if(
        (   (blobPath.indexOf('programmes')>=0)
            ||
            (blobPath.indexOf('course-listing')>=0)
        ) &&
        (blobPath.indexOf(' ')>=0)  //assuming that the space will be in the aliasses. 
    ){
    
        var blobStr = blobPath;
        const keys = Object.keys(Aliasses);
        for (let i = keys.length - 1; i >= 0; i--) {
            const key = keys[i];
            if(blobStr.indexOf(Aliasses[key])>=0){
                blobStr = blobStr.replace(new RegExp(Aliasses[key], 'g'),key );
            }
        }

        if(blobPath.indexOf('course-listing')>=0){
            blobStr = blobStr.replace('/masterclass/','/masterclasses/');
        }

        blobPath = blobStr.toLowerCase();
    }
    try {
        
        if (blobPath === 'undefined') {
            debugger;
        }

        if (blobPath.endsWith('.json')) {
            blobPath = blobPath.replace('.json', '');
        }

        if (blobPath.includes('http')) {
            //console.log("fetchJsonData: blobPath includes http: " + blobPath);
            const url = new URL(blobPath);
            blobPath = url.pathname;
            //console.log("fetchJsonData: blobPath: " + blobPath);
        }

        if (!blobPath.startsWith('/')) {
            blobPath = '/' + blobPath;
        }
        
        if (blobPath.startsWith('/api/content')) {
            blobPath = blobPath.replace('/api/content', '');
        }

        const config = useRuntimeConfig();
        const baseUrl = `${config.public.imgUri}/${config.public.contentName}`;

        // Generate a cache-busting query string parameter (timestamp)
        // const cacheBustingParam = `nocache=${Date.now()}`;
        const now = new Date();
        const cacheBustingParam = `nocache=${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}${String(now.getHours()).padStart(2, '0')}`;
        // const cacheBustingParam = '';//`nocache=${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}${String(now.getHours()).padStart(2, '0')}`;

        const requestUrl = `${baseUrl}${blobPath}.json`.toLowerCase();

        // Add the cache-busting query string parameter
        const cacheBustedUrl = `${requestUrl}?${cacheBustingParam}`;

        let cacheKey = "";
        // Check if we are on the client-side
        if (process.client) {
            // Generate a safe cache key without the cache-busting parameter
            cacheKey = CryptoJS.SHA256(requestUrl).toString();

            // Check if the data is cached
            if (cache.has(cacheKey)) {
                const cachedValue = cache.get(cacheKey);
            
                // Might return null for cache misses
                if (cachedValue !== null) {
                    if(typeof(cachedValue) == 'object'){
                        var blobStr = JSON.stringify(cachedValue);
                        for (const key in Aliasses) {
                            if (Aliasses.hasOwnProperty(key)) {
                            //console.log(`Key: ${key}, Value: ${Aliasses[key]}`);
                            blobStr = blobStr.replace(new RegExp(key, 'g'), Aliasses[key]);
                            }
                        }
                        var cachedValue2 = JSON.parse(blobStr);
                        return cachedValue2;
                    }
                    else if(typeof(cachedValue) == 'string')
                    {
                        for (const key in Aliasses) {
                            if (Aliasses.hasOwnProperty(key)) {
                                //console.log(`Key: ${key}, Value: ${Aliasses[key]}`);
                                cachedValue = cachedValue.replace(new RegExp(key, 'g'), Aliasses[key]);
                            }
                        }
                        return cachedValue;
                    }
                    else
                    {
                        debugger;

                    }
                }
            }
        }

        let response;
        let blobJson;
        if  (consumeError || process.server) {
        // if  (consumeError) {
            //BF: Catching the error as from umbraco the tab.json on a program is not mandatory to be created. Or else this will bubble and error and redirect to the 404.
            try {
                response = await fetch(cacheBustedUrl);
                blobJson = await response.json();
            }
            catch(err) {
                blobJson = undefined;
            }
        }
        else {
            response = await fetch(cacheBustedUrl);
            if (!response.ok) {
                //return JSON.stringify({});
                throw new Error(`Failed to fetch data from ${cacheBustedUrl}. Status: ${response.status}`);
            }

            blobJson = await response.json();
        }
    

        // Check if we are on the client-side
        if (process.client) {
            // Cache the JSON string with the cache key
            cache.set(cacheKey, blobJson);
        }

        var blobStr = JSON.stringify(blobJson);
        for (const key in Aliasses) {
            if (Aliasses.hasOwnProperty(key)) {
              //console.log(`Key: ${key}, Value: ${Aliasses[key]}`);
              blobStr = blobStr.replace(new RegExp(key, 'g'), Aliasses[key]);
            }
          }
        blobJson = JSON.parse(blobStr);

        // Return the JSON string
        return blobJson;
    } catch (error) {
        // Handle the error here or return an error object
        console.error(error);
        throw error;
    }
}

export const escapeRegExp = async (str: string): Promise<string> => {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

export const Aliasses = async (blobJson: string): Promise<string> => {
    var Aliasses =  JSON.parse(JSON.stringify(await fetchJsonDataOverride('aliasses.json')));
    var blobStr = JSON.stringify(blobJson);
    for (const key in Aliasses) {
        if (Aliasses.hasOwnProperty(key)) {
            blobStr = blobStr.replace(new RegExp(key, 'g'), Aliasses[key]);
        }
    }
    return blobJson;
}
export const AliassesReverse = async (blobStr: string): Promise<string> => {
    var Aliasses =  JSON.parse(JSON.stringify(await fetchJsonDataOverride('aliasses.json')));
 
    var doNav = 0;
    const keys = Object.keys(Aliasses);
    for (let i = keys.length - 1; i >= 0; i--) {
        const key = keys[i];
        if(blobStr.indexOf(Aliasses[key])>=0){
            doNav = 1;
            blobStr = blobStr.replace(new RegExp(Aliasses[key], 'g'),key );
        }
    }
    blobStr = blobStr.toLowerCase();
    return blobStr;
}
export const AliassesArr = async (): Promise<string> => {
    var Aliasses =  JSON.stringify(await fetchJsonDataOverride('aliasses.json'));
    return Aliasses;
}


export const fetchJsonDataOverride = async (blobPath: string, consumeError: boolean = false): Promise<string> => {
    try {
        
        if (blobPath === 'undefined') {
            debugger;
        }

        if (blobPath.endsWith('.json')) {
            blobPath = blobPath.replace('.json', '');
        }

        if (blobPath.includes('http')) {
            //console.log("fetchJsonData: blobPath includes http: " + blobPath);
            const url = new URL(blobPath);
            blobPath = url.pathname;
            //console.log("fetchJsonData: blobPath: " + blobPath);
        }

        if (!blobPath.startsWith('/')) {
            blobPath = '/' + blobPath;
        }
        
        if (blobPath.startsWith('/api/content')) {
            blobPath = blobPath.replace('/api/content', '');
        }

        const config = useRuntimeConfig();
        const baseUrl = `${config.public.imgUri}/${config.public.contentName}`;

        // Generate a cache-busting query string parameter (timestamp)
        const cacheBustingParam = `nocache=${Date.now()}`;

        const requestUrl = `${baseUrl}${blobPath}.json`.toLowerCase();

        // Add the cache-busting query string parameter
        const cacheBustedUrl = `${requestUrl}?${cacheBustingParam}`;

        let cacheKey = "";
        // Check if we are on the client-side
        if (process.client) {
            // Generate a safe cache key without the cache-busting parameter
            cacheKey = CryptoJS.SHA256(requestUrl).toString();

            // Check if the data is cached
            if (cache.has(cacheKey)) {
                const cachedValue = cache.get(cacheKey);
            
                // Might return null for cache misses
                if (cachedValue !== null) {
                    return cachedValue;
                }
            }
        }

        let response;
        let blobJson;
        if  (consumeError || process.server) {
        // if  (consumeError) {
            //BF: Catching the error as from umbraco the tab.json on a program is not mandatory to be created. Or else this will bubble and error and redirect to the 404.
            try {
                response = await fetch(cacheBustedUrl);
                blobJson = await response.json();
            }
            catch(err) {
                blobJson = undefined;
            }
        }
        else {
            response = await fetch(cacheBustedUrl);
            if (!response.ok) {
                //return JSON.stringify({});
                throw new Error(`Failed to fetch data from ${cacheBustedUrl}. Status: ${response.status}`);
            }

            blobJson = await response.json();
        }
    

        // Check if we are on the client-side
        if (process.client) {
            // Cache the JSON string with the cache key
            cache.set(cacheKey, blobJson);
        }

        // Return the JSON string
        return blobJson;
    } catch (error) {
        // Handle the error here or return an error object
        console.error(error);
        throw error;
    }
}

export const fetchPreviewJsonData = async (blobPath: string, consumeError: boolean = false): Promise<string> => {
    try {
        if (blobPath.includes('http')) {
      //      //console.log("fetchJsonData: blobPath includes http: " + blobPath);
            const url = new URL(blobPath);
            blobPath = url.pathname;
      //      //console.log("fetchJsonData: blobPath: " + blobPath);
        }

        if (!blobPath.startsWith('/')) {
            blobPath = '/' + blobPath;
        }
        
        if (blobPath.startsWith('/api/content')) {
            blobPath = blobPath.replace('/api/content', '');
        }

        const config = useRuntimeConfig();
        const baseUrl = `${config.public.imgUri}/${config.public.contentName}`;

        // Generate a cache-busting query string parameter (timestamp)
        const cacheBustingParam = `nocache=${Date.now()}`;

        const requestUrl = `${baseUrl}${blobPath}.json`.toLowerCase();

        // Add the cache-busting query string parameter
        const cacheBustedUrl = `${requestUrl}?${cacheBustingParam}`;

        let cacheKey = "";
        // Check if we are on the client-side
        if (process.client) {
            // Generate a safe cache key without the cache-busting parameter
            cacheKey = CryptoJS.SHA256(requestUrl).toString();

            // Check if the data is cached
            if (cache.has(cacheKey)) {
                const cachedValue = cache.get(cacheKey);
            
                // Might return null for cache misses
                if (cachedValue !== null) {
                    return cachedValue;
                }
            }
        }

        let response;
        let blobJson;
        
        response = await fetch(cacheBustedUrl);
        if (!response.ok) {
            //return JSON.stringify({});
            return '';
        }

        blobJson = await response.json();
    

        // Check if we are on the client-side
        if (process.client) {
            // Cache the JSON string with the cache key
            cache.set(cacheKey, blobJson);
        }

        // Return the JSON string
        return blobJson;
    } catch (error) {
        // Handle the error here or return an error object
        console.error(error);
        throw error;
    }
}
// Function to parse JSON using Zod
export function parseJSON<T extends z.Schema<any>>(schema: T, json: string): z.infer<T> | [] {
    try {

        return schema.parse(json);
    } catch (err) {
        if (err instanceof ZodError) {
      //      //console.log("ZodError:" + JSON.stringify(err.issues, null, 2));
        } else {
      //      //console.log("parseJSON ERROR: " + JSON.stringify(err, null, 2))
        }
        
        return [] as z.infer<T>;
    }
}

// Function to parse JSON using Zod
export function parseJSONObject<T extends z.Schema<any>>(schema: T, json: string): z.infer<T> | {} {
    try {
        return schema.parse(json);
    } catch (err) {
        if (err instanceof ZodError) {
      //      //console.log("ZodError:" + JSON.stringify(err.issues, null, 2));
        } else {
      //      //console.log("parseJSON ERROR: " + JSON.stringify(err, null, 2))
        }
        
        return {} as z.infer<T>;
    }
}

export function parseJSONObjectV2<T extends z.Schema<any>>(schema: T, json: string): z.infer<T> | {} {
    try {
        const jsonObject = JSON.parse(json);
        const result = schema.parse(jsonObject);
        return result;
    } catch (err) {
        debugger;
        if (err instanceof ZodError) { 
            console.log("ZodError:" + JSON.stringify(err.issues, null, 2));
            console.log("ZodError json:" + JSON.stringify(JSON.parse(json), null, 2));
        } else { 
            console.log("parseJSON ERROR: " + JSON.stringify(err, null, 2))
            console.log("ZodError json:" + json);
        }
        
        return {} as z.infer<T>;
    }
}

export async function getBlobContent(blobUrl: string, bustCache = false) {
    let blobPath = bustCache ? `${blobUrl}?v=${Date.now()}` : blobUrl;
    if (!blobPath.startsWith('/')) {
        blobPath = '/' + blobPath;
    }

    const config = useRuntimeConfig();
    const baseUrl = `${config.public.imgUri}/${config.public.contentName}`;
    const requestUrl = `${baseUrl}${blobPath}`.toLowerCase();

    const response = await fetch(requestUrl);
    const blobXml = await response.text();

    return blobXml;
}
